import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
  getGPA,
  addGPA as postGPA,
  updateGPA as putGPA,
  deleteGPA as removeGPA,
  activateDeactivateGPA as activateGPA
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Table Column Names
export const fetchGPATableColumnNames = createAsyncThunk("gpa/fetchTableColumnNames", async (gpa, thunkAPI) => {
    try {
      const response = await getHeaders(gpa); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Question Type
export const fetchAllGPA = createAsyncThunk("gpa/fetchAll", async (gpa, thunkAPI) => {
    try {
      const response = await getGPA(gpa); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Question Type
export const createGPA = createAsyncThunk("gpa/add", async (gpa, thunkAPI) => {  
    try {
        const response = await postGPA(gpa);
        toast.success(t(response.message));
        return response;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Question Type
export const updateGPA = createAsyncThunk("gpa/update", async (gpa, thunkAPI) => {
    try {
        const response = await putGPA(gpa);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Question Type
export const deleteGPA = createAsyncThunk("gpa/delete", async (gpa, thunkAPI) => {
    try {
        const response = await removeGPA(gpa);
        toast.success(t(response.message));
        return response.data;
    } catch (error) {
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Activate Deactivate Question Type
export const activateDeactivateGPA = createAsyncThunk("gpa/activateDeactivate", async (gpa, thunkAPI) => {
  try {
    const response = await activateGPA(gpa);
    toast.success(t(response.message));
    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});